import React, { useContext, useMemo } from 'react';
import PageBookmarkBtn from 'components/PageBookmarkBtn/PageBookmarkBtn';
import {
	EditGameCategoryContext,
	IEditGameCategoryContext,
} from 'modules/Entertainment/Games/EditGameCategory/editGameCategoryState/editGameCategoryContext';
import style from './ControlPanel.module.scss';

const ControlPanel: React.FC = () => {
	const { changeVisibleForm, IDsSelectedLanguages, visibleForm, translations } =
		useContext<IEditGameCategoryContext>(EditGameCategoryContext);

	const hasTranslationError = useMemo(() => {
		if (!IDsSelectedLanguages.length) {
			return false;
		}
		const someTranslationIsEmpty = translations.some((translation) => translation.name === '');
		return someTranslationIsEmpty;
	}, [IDsSelectedLanguages, translations]);

	return (
		<div className={style.container} data-test="ControlPanel">
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('mainForm')}
				isActive={visibleForm === 'mainForm'}
				btnName="mainInfoBookmark"
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('translations')}
				isActive={visibleForm === 'translations'}
				btnName="translationsBookmark"
				isError={hasTranslationError}
			/>
		</div>
	);
};

export default ControlPanel;
